// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"228":"c1d91e7c","439":"518df02c","521":"0de438ad","594":"0d6382fa"}[chunkId] + ".js";
};